import { RoutePageType } from "@routes/interfaces"
import MotoristaLista from "./pages/MotoristaLista"
import MotoristaCriar from "./pages/MotoristaCriar"

const motoristaPages: RoutePageType[] = [
    {key: 'cadastroMotoristaLista', element: MotoristaLista},
    {key: 'cadastroMotoristaCriar', element: MotoristaCriar},
]

export default motoristaPages